"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logRequestSchema = exports.logChangeProposalRequestSchema = exports.logChangeItemRequestSchema = void 0;
const createRequest_schema_1 = require("../create/createRequest.schema");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const zod_1 = require("zod");
const commonLogRequestSchema = zod_1.z
    .object({
    from: contact_schema_1.contactSchema,
    receivedVia: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia),
    receivedDate: datetime_schema_1.datetimeSchema,
})
    .strict();
exports.logChangeItemRequestSchema = createRequest_schema_1.createRequestSchema.options[0].merge(commonLogRequestSchema).strict();
exports.logChangeProposalRequestSchema = createRequest_schema_1.createRequestSchema.options[1].merge(commonLogRequestSchema).strict();
exports.logRequestSchema = zod_1.z.union([exports.logChangeItemRequestSchema, exports.logChangeProposalRequestSchema]);
//# sourceMappingURL=logRequest.schema.js.map